import React, { useState } from "react"
import { Container, Form} from "reactstrap"
import { useFormik } from "formik"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../../components/ResultHandler"
import FormButtonHandler from "../../../../components/FormButtonHandler"
import { useResponse } from "../../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../../hooks/useGetInstence"
import { FINE_REQUIRED_FIELDS } from "./CONSTANT"
import * as Yup from "yup"
import FineForm from "./FineForm"
import { editFine, getFine } from "../../../../api/fine"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

FINE_REQUIRED_FIELDS.forEach((f) => {
    initialValues[f.key] = TYPES[f.type] || "";
    
    if (f.type == "file") {
        FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
            "This Field Is Required"
        );
    } else if (f.type == "select" && f.isMulti) {
        FIELDS_VALIDATION[f.key] = Yup.array();
    } else {
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
    }
});

const EditFine = () => {
    let navigate = useHistory()
    const { t } = useTranslation()
    const {id: fineId} = useParams()
    const [editedFine, setEditedFine] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getFine,
        fineId,
        response => {
            setEditedFine({
                ...response.data.fine,
                picture_preview: response.data.fine.picture,
                picture: null,
            })
        }
    )

    const { setData, loading, error, success } = useResponse(editFine, () => {
        navigate.goBack()
    })
    
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {...editedFine},
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: (values) => {
            let data = new FormData()

            Object.keys(values).map(key => {
                if(values[key]){
                    data.append(key, values[key])
                }
            })

            setData({ type: "edit", id: fineId, data })
        },
    })

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Fines")}
                        breadcrumbItem={t("btns.Edit") + " " + t("Fine")}
                    />
                    
                        {editedFine && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <FineForm validation={validation} />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>
                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditFine